import { graphql } from '../../graphql/generated';

export const DOCTOR_SETTINGS_QUERY = graphql(`
  query DoctorSettings($doctorId: ID!) {
    doctor(id: $doctorId) {
      id
      salutation
      preTitle
      postTitle
      firstName
      lastName
      name
      specialist
      street
      zip
      city
      email
      phone
      billingPreference
      autoDiagnose
      addEmptyLabels
      printTransferDocument
      addZplLabels
    }
  }
`);

export const UPDATE_DOCTOR_SETTINGS_MUTATION = graphql(`
  mutation UpdateDoctorSettings($id: ID!, $input: DoctorSettingsInput!) {
    updateDoctorSettings(id: $id, input: $input) {
      id
    }
  }
`);
